import { useFeatureFlag, useIsBizyEnabledForUser } from '@bonusly/who-am-i';

export const DESKTOP_DOWNLOAD_URLS = {
	'mac-arm64': 'https://bizy-desktop-releases.s3.us-east-2.amazonaws.com/latest/mac-arm64/Bizy-arm64-mac.zip',
	'mac-x64': 'https://bizy-desktop-releases.s3.us-east-2.amazonaws.com/latest/mac-x64/Bizy-mac.zip',
	win: 'https://bizy-desktop-releases.s3.us-east-2.amazonaws.com/latest/win/Bizy-Setup.exe',
} as const;

export type DetectedDesktopPlatform = 'mac' | 'win';

// Apple Silicon vs Intel can't be reliably distinguished from the UA on Safari
// (both report "Intel Mac OS X"), so we return a coarse 'mac' / 'win'. The
// arm64-vs-x64 choice is made by the user via the two macOS buttons.
export function useDetectedDesktopPlatform(): DetectedDesktopPlatform | null {
	const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
	if (/iPhone|iPad|iPod|Android|Mobile/i.test(ua)) return null;
	if (/Macintosh|Mac OS X/.test(ua)) return 'mac';
	if (/Windows NT/.test(ua)) return 'win';
	return null;
}

export function useIsBizyDesktopDownloadEnabled(): boolean {
	const isBizyEnabled = useIsBizyEnabledForUser();
	const flagEnabled = useFeatureFlag('bizy-desktop-download');
	const platform = useDetectedDesktopPlatform();
	return isBizyEnabled && flagEnabled && platform !== null;
}
